export default __webpack_public_path__ + "static/media/Battery replacement.38b7576e.png";